import { landingRequestLogPost } from '@/src/shared/api'
import { cookies } from '@/src/shared/lib/cookies'
import { urlCache } from '@/src/shared/lib/urlCache'

interface ApiResponsePost {
  success: boolean
}

export async function send() {
  try {
    const cookiesObj = {}
    cookies.getAll().forEach((item) => (cookiesObj[item.name] = item.value))
    await landingRequestLogPost<ApiResponsePost, any>({
      query: urlCache.searchParamsGet('enter'),
      cookies: cookiesObj,
    })
  } catch (e) {}
}
